module.exports = __webpack_public_path__ + "img/price_list_it.2c561bfd.png";